var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    class: [_vm.isH5 ? 'feedback-container-h5' : '', 'feedback-container']
  }, [_c('div', {
    staticClass: "feedback-like",
    on: {
      "mouseenter": function ($event) {
        _vm.isLikeIconHover = true;
      },
      "mouseleave": function ($event) {
        _vm.isLikeIconHover = false;
      },
      "click": _vm.onLikeIconClick
    }
  }, [_c('Icon', {
    attrs: {
      "file": _vm.likeIcon,
      "width": "16px",
      "height": "16px"
    }
  }), _vm.isPC ? _c('div', {
    staticClass: "tooltip"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.满意")) + " "), _c('div', {
    staticClass: "tooltip-arrow"
  })]) : _vm._e()], 1), _c('span', {
    staticClass: "divider"
  }), _c('div', {
    staticClass: "feedback-dislike",
    on: {
      "mouseenter": function ($event) {
        _vm.isDislikeIconHover = true;
      },
      "mouseleave": function ($event) {
        _vm.isDislikeIconHover = false;
      },
      "click": _vm.onDislikeIconClick
    }
  }, [_c('Icon', {
    attrs: {
      "file": _vm.dislikeIcon,
      "width": "16px",
      "height": "16px"
    }
  }), _vm.isPC ? _c('div', {
    staticClass: "tooltip"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.不满意")) + " "), _c('div', {
    staticClass: "tooltip-arrow"
  })]) : _vm._e()], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }